const digest = '68818e3b7ab4284a1df25830e904424f686abc285300124c342dadbdf4c4c272';
const css = `._iconFillMinimal_1jbz7_1 svg{fill:#737373}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'iconFillMinimal': '_iconFillMinimal_1jbz7_1' };
export const iconFillMinimal = '_iconFillMinimal_1jbz7_1';
export { css, digest };